import React from "react";
import Team from "../components/Team";
// import Intro from "../components/Intro"; // Commented out if not used
import Connect from "../components/Connect";
import ServiceHeader from "../components/ServiceHeader";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import team_img from "../static/img/team.png";

function TeamPage() {
  return (
    <>
      <Nav />
      <ServiceHeader
        image={team_img}
        title={"Our Team"}
        description={
          "The strength of SPP Insolvency Professionals LLP lies in its integrated expertise. Our IPE is led by a core team of Chartered Accountants, Company Secretaries, and domain specialists—including Registered Insolvency Professionals, Valuers, and Forensic Auditors—who bring precision, compliance, and strategic insight to every mandate. Backed by a multi-disciplinary support team of over 60 professionals and associates, we deliver client-focused insolvency and restructuring solutions with speed, integrity, and regulatory rigor."
        }
        overlayDescription
      />
      <Team />
      <Connect />
      <Footer />
    </>
  );
}
export default TeamPage;
